/**
 * @generated SignedSource<<925cfa0b4cb2c883d60f90cd3cc3268a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardUserSuggestedSkillsQuery$variables = {
  skip: boolean;
  studentId: string;
  targetId: string;
};
export type DashboardUserSuggestedSkillsQuery$data = {
  readonly studentSuggestedSkills?: ReadonlyArray<{
    readonly id: string;
  }>;
};
export type DashboardUserSuggestedSkillsQuery = {
  response: DashboardUserSuggestedSkillsQuery$data;
  variables: DashboardUserSuggestedSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetId"
},
v3 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "studentId",
            "variableName": "studentId"
          },
          {
            "kind": "Variable",
            "name": "targetId",
            "variableName": "targetId"
          }
        ],
        "concreteType": "StudentSkillNode",
        "kind": "LinkedField",
        "name": "studentSuggestedSkills",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardUserSuggestedSkillsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DashboardUserSuggestedSkillsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "50277776d1f162b9f27223d258f81497",
    "id": null,
    "metadata": {},
    "name": "DashboardUserSuggestedSkillsQuery",
    "operationKind": "query",
    "text": "query DashboardUserSuggestedSkillsQuery(\n  $studentId: ID!\n  $targetId: ID!\n  $skip: Boolean!\n) {\n  studentSuggestedSkills(studentId: $studentId, targetId: $targetId) @skip(if: $skip) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae55f73d45daed7af3a968930615ee06";

export default node;
